<template>
  <view-wrapper
    prefix="Add new"
    name="Group"
    path="groups"
    :showCancel="true"
    addedText="Create group"
    :addedFunc="createGroup"
    :hasChangesBeenMade="hasChangesBeenMade"
    :loading="loading"
  >
    <wrapper class="mb-5" :checkForChildFocused="true">
      <grafokett-input
        type="text"
        labelPlaceholder="Group name"
        v-model="groupName"
        :editable="true"
      />
    </wrapper>
    <wrapper>
      <p>Parent group</p>
      <div class="w-64">
        <drop-down
          v-model="parentGroup"
          :options="getGroups"
          value-property="groupName"
          searchProp="groupName"
          placeholder="Select parent group"
        />
      </div>
    </wrapper>
  </view-wrapper>
</template>

<script>
import GrafokettInput from "../components/forms/Input.vue";
import DropDown from "../components/forms/DropDown";
export default {
  components: {
    GrafokettInput,
    DropDown
  },
  data() {
    return {
      groupName: "",
      addedUsers: [],
      parentGroup: {},
      loading: false
    };
  },
  methods: {
    hasChangesBeenMade() {
      return (
        this.groupName !== "" ||
        this.addedUsers.length > 0 ||
        this.parentGroup.length > 0
      );
    },
    async createGroup() {
      this.loading = true;
      const payload = {
        name: this.groupName,
        parentGroupId: this.parentGroup.id ? this.parentGroup.id : null
      };
      await this.$store.dispatch("DATA/ADD_NEW_GROUP", payload);
      this.loading = false;
    }
  },
  mounted() {
    this.$store.dispatch("USERS/GET").catch(err => console.log(err));
    this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
  },
  computed: {
    getGroups() {
      return this.$store.getters["GROUPS/GROUPS"];
    },
    getUsers() {
      var users = this.$store.getters["USERS/USERS"].map(e => {
        return {
          id: e.id,
          name: `${e.firstName} ${e.lastName}`,
          email: e.email
        };
      });
      return users;
    }
  }
};
</script>
